import { render, staticRenderFns } from "./StatisticsRadioGroup.vue?vue&type=template&id=4dbeaa17&scoped=true&"
import script from "./StatisticsRadioGroup.vue?vue&type=script&lang=js&"
export * from "./StatisticsRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbeaa17",
  null
  
)

export default component.exports